import React, { useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store";
import Theme from "components/template/Theme";
import Layout from "components/layout";
// import history from "./history";
// import mockServer from "./mock";
// import appConfig from "configs/app.config";
import "./locales";
import "./App.css";
import { ErrorFallback } from "components/layout/ErrorFallback";
import { ScrollToTop } from "components/shared";
import packageJson from "../package.json";

import * as Sentry from "@sentry/react";
import { Environment, getEnvironment } from "utils/getEnvironment";
import { TooltipProvider } from "components/ui/Tooltip/tooltips";

const env = import.meta.env;
const environment = env.MODE;

Sentry.init({
  dsn: env.VITE_SENTRY_DSN,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  debug: getEnvironment(Environment.DEVELOPMENT),
  environment,
});

/**
 * Set enableMock(Default false) to true at configs/app.config.js
 * If you wish to enable mock api
//  */
// if (environment !== "production" && appConfig.enableMock) {
//   mockServer({ environment });
// }
const queryClient = new QueryClient();

const myErrorHandler = (error, info) => {
  // Do something with the error
  // E.g. log to an error logging client here
};

function App() {
  useEffect(() => {
    const caching = () => {
      let version = localStorage.getItem("version");

      if (version !== packageJson.version) {
        if ("caches" in window) {
          caches.keys().then((names) => {
            names.forEach((name) => {
              caches.delete(name);
            });
          });

          window.location.reload(true);
        }

        localStorage.removeItem("version");
        localStorage.setItem("version", packageJson.version);
      }
    };

    caching();
  }, [packageJson.version]);

  return (
    <Sentry.ErrorBoundary fallback={ErrorFallback} onError={myErrorHandler}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter >
            <TooltipProvider>
              <Theme>
                <QueryClientProvider client={queryClient}>
                  <Layout />
                </QueryClientProvider>
              </Theme>
            </TooltipProvider>
            <ScrollToTop />
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </Sentry.ErrorBoundary>
  );
}

export default App;
